module.exports = __webpack_public_path__ + "static/media/NASStatusUserGuide.cccc6d48.pdf";